import React from 'react';
import { 
  emphasize,
  ThemeProvider,
  withStyles,
} from '@material-ui/core/styles';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Chip from '@material-ui/core/Chip';
// import HomeIcon from '@material-ui/icons/Home';
import { ReactComponent as HomeIcon } from '../images/svgicon/home.svg';
import { MdKeyboardArrowRight } from "react-icons/md";
import ThemeControls from "./AllThemesControl";
import {useLocation} from 'react-router-dom';

import { useNavigate } from 'react-router-dom';

const StyledBreadcrumb = withStyles((theme) => ({
  root: {
    
    backgroundColor:'transparent',
    // backgroundColor: theme.palette.grey[100],
    height: theme.spacing(0),
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.grey[300],
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(theme.palette.grey[300], 0.12),
    },
  },

}))(Chip);


export default function BreadcrumbsGrp() {
  const {useStyles} = ThemeControls;
  const classes = useStyles();
  const path = useLocation();
  const idToLabel = path?.state?.idToLabel;
  let pathString = String(path.pathname);
  var _tmpArray = pathString.replace(/([A-Z])/g, ' $1').split(" ");
   
  var  _pathString = _tmpArray.join(" ");
   
  let arr = _pathString.split('/');
   

  let arry = pathString.split('/');
  let _link=arry.join(','+'/');
  let _arry = _link.split(',');


  let navigate = useNavigate()
  const [open, setOpen] = React.useState();
  const [forec, setForce] = React.useState(0);
  

  React.useEffect(()=>{
    if(open>=0){
      let path = ""
      for (let i = 0; i <= open; i++) {
        path = path+_arry[i];
         
      }
      navigate(path);
    }else{
      setOpen(0)
    }
},[forec])

function capitalizeFirstLetter(str) {
  // Check if the input is a non-empty string
  if (typeof str !== 'string' || str.length === 0) {
    return str;
  }

  // Capitalize the first letter and concatenate with the rest of the string
  return str.charAt(0).toUpperCase() + str.slice(1);
}

  return (
   
    <ThemeProvider>
      <Breadcrumbs
       aria-label="breadcrumb"
        className={classes.breadCrmb}
        // separator={<NavigateNextIcon fontSize="small" />}
        // separator=">"
        separator={<MdKeyboardArrowRight/>}
        >
            {arr.map((item,index)=>{
              let homeIcon = null;
              // console.log(!isNaN(item))
              // console.log(idToLabel)
              const StringItem = capitalizeFirstLetter(item)
              if(item!==" " && item!=="  "){
                if(item==="" && index===0){
                  homeIcon = <StyledBreadcrumb  label="Home"/>
                }
                let label = StringItem;

                if (index === arr.length - 1 && !isNaN(item)) {
                    label = idToLabel ? idToLabel : StringItem;
                }
                const isLast = index === arr.length - 1;
                return(
                <div key={index} className={classes.Brdcrb}>
                  {/* <h1>{item}</h1> */}
                  
                  {isLast?<StyledBreadcrumb
                    component="a"
                    label={label}
                    icon={homeIcon}
                  />:<StyledBreadcrumb
                  component="a"
                  label={label}
                  icon={homeIcon}
                  // href={item}
                  // onClick={//console.log('\nbutton cliked '+ item)}
                  // onClick= {handleClick(),setOpen(index) }
                  onClick={()=>{setOpen(index);setForce(forec+1)}}
                />}
                  </div>
                )
              }
              return null;
            })}
      </Breadcrumbs>
    </ThemeProvider>
   
  );
}
